module.exports = __webpack_public_path__ + "img/cross-light.46b7bca.svg";